import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import { ChevronRight } from "react-feather"

import CoolPage from "../components/CoolPage"

import "./HotelRestaurants.less"

// #TODO el enlace para reservar el almuerzo

const texts = {
  h1: {
    es: "Bienvenido al restaurante de NH",
    ch: "欢饮来到NH酒店餐厅"
  },
  sections: [
    {
      title: {
        es: "Desayuno",
        ch: "早餐"
      },
      text: {
        es: "Podrá disfrutar de su desayuno buffet de 10 de la mañana a 12 del mediodía",
        ch: "您可以享受酒店自助早餐从上午10点到中午12点"
      }
    },
    {
      title: {
        es: "Comidas",
        ch: "午餐"
      },
      text: {
        es: "El restaurante está abierto de 13 a 16 para comidas y de 20 a 24 para cenas",
        ch: "营业时间: 午餐从13点到16点; 晚餐20点到24点"
      },
      button: {
        es: "Reservar una mesa",
        ch: "预订就餐"
      }
    }
  ],
  menuTitle: {
    es: "Bienvenido al restaurante de NH",
    ch: "餐厅菜单"
  },
  menuText: {
    es: "Explora nuestra carta de riquísimos platos y deliciosos postres",
    ch: "了解我们菜单上的美味佳肴"
  },
}

const lang = "ch"

/* eslint-disable react/prefer-stateless-function */
class Tepa2 extends React.PureComponent {
  render() {
    return (
      <CoolPage
        containerProps={{ className: "tepa" }}
        title="NH: Palacio de Tepa"
        barColor={[255, 255, 255]}
        className="tepaPage tepaRestaurant"
      >
        <img
          className="header-image"
          src="/static/img/nh/restaurant-header.jpg"
        />
        
        <h1>{texts.h1[lang]}</h1>
        
        <div className="section a">
          <div className="faux">
            <h1>{texts.sections[0].title[lang]}</h1>
            <p>{texts.sections[0].text[lang]}</p>
          </div>
          <div>
            <h1>{texts.sections[0].title[lang]}</h1>
            <p>{texts.sections[0].text[lang]}</p>
          </div>
        </div>
        
        <div className="section b">
          <div className="faux">
            <h1>{texts.sections[1].title[lang]}</h1>
            <p>{texts.sections[1].text[lang]}</p>
            <b className="link">{texts.sections[1].button[lang]}</b>
          </div>
          <div>
            <h1>{texts.sections[1].title[lang]}</h1>
            <p>{texts.sections[1].text[lang]}</p>
            <b className="link" onClick={() => alert("DISABLED")}>
              {texts.sections[1].button[lang]}
              {" >"}
              </b>
          </div>
        </div>
        
        <div className="menu" onClick={this.props.gotoMenu}>
          <div>
            &nbsp;
            <img src="/static/img/nh/plato.png" />
          </div>
          <div>
            <h1>{texts.menuTitle[lang]}</h1>
            <p>{texts.menuText[lang]}</p>
          </div>
        </div>
        
      </CoolPage>
    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoMenu: () => goto(`/catalogo/tepa/menu`),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tepa2)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/HotelRestaurants.jsx